/**
 * Base URL for Supabase Edge Function calls.
 *
 * On Vercel deployments, requests go through a same-origin rewrite
 * (`/sfn/*` → Supabase `/functions/v1/*`) to avoid CORS issues.
 * In local dev mode, calls go directly to the Supabase functions URL.
 */
export const EDGE_FN_BASE: string = import.meta.env.DEV
  ? `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`
  : '/sfn';
